import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import SimpleCard from './SimpleCard';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '90%',
  },
});


class RadioButtonsGroup extends React.Component {
  constructor(props){
    super(props);
    if (this.props.selectedOption){
      this.state = this.props.selectedOption; 
    }else{
      // this.state = {
      //   name: 'Test', //prevent uncontrolled component warning
      //   phone: '555123456',
      //   email: 'test@galicloud.com',
      //   team: 'Test',
      //   city: 'Test',
      // };
      this.state = {
        name: '', //prevent uncontrolled component warning
        phone: '',
        email: '',
        team: '',
        city: '',
      };
    }
  }
  handleChange = (key) => (event) => {

    this.setState({ [key]: event.target.value });
    this.props.choiceHandler( { ...this.state, [key]: event.target.value } );
  };

  render() {
    const { classes } = this.props;

    return (
        <div>
      <div className={classes.root}>
      <TextField
          required
          id="name"
          label="Nombre"
          value={this.state.name}
          onChange={this.handleChange('name')}
          className={classes.textField}
          margin="normal"
        />      
      <TextField
          required
          id="phone"
          label="Teléfono "
          value={this.state.phone}
          onChange={this.handleChange('phone')}
          className={classes.textField}
          margin="normal"
        />      
      <TextField
          required
          id="email"
          label="Email"
          value={this.state.email}
          onChange={this.handleChange('email')}
          className={classes.textField}
          margin="normal"
        />      
      <TextField
          required
          id="team"
          label="Equipo"
          value={this.state.team}
          onChange={this.handleChange('team')}
          className={classes.textField}
          margin="normal"
        />      
      <TextField
          required
          id="city"
          label="Ciudad del club"
          value={this.state.city}
          onChange={this.handleChange('city')}
          className={classes.textField}
          margin="normal"
        />      
      </div>
        <SimpleCard headline='Datos de contacto' content={
        <Typography type="body1"> 
        Introduce tus datos para poder ponernos en contacto contigo.<br /><br />
        <strong>Atención:</strong> Cada club que inscriba más de 2 equipos disfrutará de una bonificacion del 50% para inscribir al 3º y sucesivos equipos.
        </Typography>
      }/>
      </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioButtonsGroup);


// WEBPACK FOOTER //
// ./src/components/InputContactData.jsx